var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"rounded-lg ml-2",attrs:{"text":"","outlined":"","color":"#41916b"},on:{"click":function($event){return _vm.$router.push(_vm.route)}}},[_vm._v(" "+_vm._s(_vm.description)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }